export const desiredOrderJeem1 = [
  'in_turn',
  'pending',
  'second_review',
  'late_requests',
  'Follow_comments_of_the_request_study',
  'Processing_Request_by_Authorized_Body',
  'total_count',
  'certificate_issued',
  'Send_back_to_Client',
]

export const desiredOrderSaber = [
  'in_turn',
  'pending',
  'No_Action_Taken',
  'Completed_payment_by_facility',
  'Waiting_To_Recieve_Request_By_CB',
  'Send_back_to_Client',
  'total_load',
  'completed',
  'canceled',
  'certificate_issued',
  'total_count',
]
